import React from "react";
import "./style.scss";

const Loader = () => {
  return (
    <div className="skBody">
      <div className="skTitle"></div>
      <div className="skInfo">
        <div className="skInfoItem"></div>
        <div className="skInfoItem"></div>
      </div>
      <div className="skDiscription"></div>
      <div className="skDiscription"></div>
      <div className="skDiscription"></div>
      <div className="skUpdatedBy"></div>
    </div>
  );
};

export default Loader;
